"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_easy_emoji_1 = __importDefault(require("react-easy-emoji"));
const styled_components_1 = __importDefault(require("styled-components"));
function PublicodesBlock({ source }) {
    const baseURL = location.hostname === 'localhost' ? '/publicodes' : 'https://publi.codes';
    return (jsx_runtime_1.jsxs("div", Object.assign({ style: {
            position: 'relative',
        } }, { children: [jsx_runtime_1.jsx("pre", Object.assign({ className: "ui__ code" }, { children: jsx_runtime_1.jsx("code", { children: source }, void 0) }), void 0), jsx_runtime_1.jsxs(exports.LaunchButton, Object.assign({ href: `${baseURL}/studio?code=${encodeURIComponent(source)}`, target: "_blank" }, { children: [react_easy_emoji_1.default('⚡'), " Lancer le calcul"] }), void 0)] }), void 0));
}
exports.default = PublicodesBlock;
exports.LaunchButton = styled_components_1.default.a `
	position: absolute;
	bottom: 5px;
	right: 10px;
	color: white !important;
`;
